import axios from "axios";
import { createContext, useContext, useState } from "react";
import { API_LOGIN_ADMIN } from "../api/index";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const oldInfo = JSON.parse(localStorage.getItem("adminHandi"));
  const [currentUser, setCurrentUser] = useState(oldInfo || null);
  const [userType, setUserType] = useState(
    localStorage.getItem("userType") || null
  );
  const [adminAuth, setAdminAuth] = useState(
    localStorage.getItem("adminHandiAuth") || null
  );
  // const [ loading, setLoading ] = useState(true);
  const config = {
    headers: {
      Authorization: `Bearer ${adminAuth}`,
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${adminAuth}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const loginAdmin = async (data, cb) => {
    console.log("data is going");
    return axios.post(API_LOGIN_ADMIN, data).then((res) => {
      if (res.data.status === "success") {
        const admin = res.data.data;
        setUserType(admin.user_type);
        localStorage.setItem("userType", admin.user_type);
        setAdminAuth(admin.admin_token);
        localStorage.setItem(
          "adminHandi",
          JSON.stringify({
            admin_token: admin.admnin_token,
            admin_id: admin.admin_id,
            first_name: admin.first_name,
            last_name: admin.last_name,
            mobile_no: admin.mobile_no,
            email: admin.email,
            user_type: admin.user_type,
          })
        );

        setCurrentUser({
          admin_token: admin.admnin_token,
          admin_id: admin.admin_id,
          first_name: admin.first_name,
          last_name: admin.last_name,
          mobile_no: admin.mobile_no,
          email: admin.email,
          user_type: admin.user_type,
        });
        localStorage.setItem("adminHandiAuth", admin.admin_token);
        cb();
      } else {
        return res.data;
      }
    });
  };

  const logoutAdmin = () => {
    setCurrentUser(null);
    localStorage.removeItem("userType");
    localStorage.removeItem("adminHandi");
    localStorage.removeItem("adminHandiAuth");
  };

  const value = {
    currentUser,
    setCurrentUser,
    loginAdmin,
    logoutAdmin,
    adminAuth,
    config,
    userType,
    config2,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
      {/* {!loading && children} */}
    </AuthContext.Provider>
  );
};
